var map = {
	"./en-US.json": [
		36110,
		"default-src_app_i18n_en-US_json"
	],
	"./es.json": [
		57893,
		"default-src_app_i18n_es_json"
	],
	"./pt-BR.json": [
		54050,
		"default-src_app_i18n_pt-BR_json"
	],
	"./ru.json": [
		59846,
		"default-src_app_i18n_ru_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65493;
module.exports = webpackAsyncContext;